import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as c } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = c((e, a) => /* @__PURE__ */ s.jsx(
  r,
  {
    ref: a,
    ...e,
    image: (t) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "currentColor",
        viewBox: "0 0 48 48",
        ...t,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4125",
              width: 47,
              height: 47,
              x: 1,
              y: 1,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx("path", { d: "M1.264 1.224H47.46v46.461H1.264z" })
            }
          ),
          /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_2974_4125)", children: [
            /* @__PURE__ */ s.jsx("path", { d: "M24 30.15a6.52 6.52 0 1 0 0-13.04 6.52 6.52 0 0 0 0 13.04" }),
            /* @__PURE__ */ s.jsx("path", { d: "M39.361 35.33c-.07 0-.13-.01-.2-.03-2.93-.81-4.98-3.49-4.98-6.52l-.04-5.98c-.54-5.27-4.88-9.3-10.08-9.3-5.28 0-9.62 4.02-10.09 9.36l-.04 5.93c0 3.03-2.05 5.71-4.98 6.52-.4.11-.81-.12-.92-.52s.12-.81.52-.92c2.28-.63 3.88-2.72 3.88-5.08l.04-5.99c.55-6.19 5.52-10.8 11.59-10.8 5.98 0 10.96 4.61 11.58 10.72l.05 6.06c0 2.36 1.59 4.45 3.88 5.08.4.11.63.52.52.92-.1.33-.4.55-.73.55" })
          ] })
        ]
      }
    )
  }
));
i.displayName = "AgencyAcneIcon";
export {
  i as AgencyAcneIcon,
  i as default
};
//# sourceMappingURL=index.js.map
